export const EARN_ASSET_STATUS = {
  ACTIVE: 'ACTIVE',
  COMING_SOON: 'COMING_SOON',
} as const

export type EarnAssetStatus = (typeof EARN_ASSET_STATUS)[keyof typeof EARN_ASSET_STATUS]

export interface EarnAsset {
  asset: string
  portfolioId: string | null
  productName: string
  myEarnRate: number | null
  customerEarnRate: number | null
  availableFunds: null
  earningSince: string | null
  status: EarnAssetStatus
}

export interface EarnDashboardResponse {
  fundsOverview: {
    allocatedFunds: string
    availableFunds: null
  }
  totalEarnings: {
    fromMyAllocation: string
    fromCustomers: string
    total: string
  }
  customerRewardsProgram: {
    totalBalanceAcrossCustomers: null
    optInRate: null
    optInUsers: null
    distributedEarnings: string
    optedInTotal: string
    remainingTotal: string
  }
  earnAssets: EarnAsset[]
}

export interface EarnAssetDetailsResponse {
  asset: string
  walletId: string
  productName: string
  myEarnRate: number | null
  customerEarnRate: number | null
  fundsOverview: {
    allocatedFunds: string
    totalCustomerEligibleFunds: string
  }
  earningsSummary: {
    myLifetimeEarnings: string
    customerEarningsReceived: string
    distributedEarningsToCustomers: string
  }
}
